import $, { nodeName } from 'jquery';
import Foundation from 'foundation-sites';
import Swiper, { Pagination } from 'swiper';
import { TimelineItem } from './timeline_item';
import { TimelineYearslider } from './timeline_yearslider';
import { isMobile } from './util';
import { TimelineFilter } from './timeline_filter';
import gsap from 'gsap/gsap-core';

Swiper.use([Pagination]);


$(function() {
  const tlItems = [];
  $(".birthday-item").each(function () {
    const tlItem = new TimelineItem(this);
    tlItems.push(tlItem);
    //tl.addItem(tlItem);
  })
  const yearslider = new TimelineYearslider($('.timeline-year-slider'));
  const filter = new TimelineFilter($('.timeline-category-filter'));
  const tl = new Timeline(tlItems);


  $(document).on('tlItemsReady', function(e) {
    yearslider.initialShowYearSlider();
    yearslider.attachScrollTrigger();
    yearslider.attachItemScrollTriggers();
  })

  $(document).on('filterChange', function(e, arr) {
    console.log('filterChange', e, arr);
    tl.filterElements(arr);
    if (arr.length > 0) { 
      yearslider.hideYearSlider();
    } else {
      yearslider.showYearSlider();
    }
  })
})

class Timeline {
  constructor(items) {
    this.activeElement = null;
    this.elements = items;
    this.elementHidePromises = [];
    this.swiper = null;
    this.createSwiper(); 

    const _self = this;
    this.elements.map(function(element, i) { 
      element.setTimeline(_self);
      element.setIndex(i);
      _self.elementHidePromises.push(element.initialHide());
      $(element).on("openOverlayEvent", function (e) {
        _self.handleItemOpenOverlayEvent(e);
      });
      $(element).on("closeOverlayEvent", function (e) {
        _self.handleItemCloseOverlayEvent(e);
      });

      _self.addSwiperSlideFromCard(element);
    })
    Promise.all(this.elementHidePromises)
      .then((values) => { 
        $('.timeline-loader').fadeOut(400, function() { 
          $('.timeline-grid').fadeIn().css('display', 'grid');
          $(document).trigger('tlItemsReady');
        });
      })
      .catch((errors) => { console.error(errors) })

  }

  /**
   * deprecated
   * addsItem to Timeline
   * @param {jQuery Object} item 
   */
  addItem(item) {
    this.elements.push(item);
    item.index = this.elements.length - 1;
    this.elementHidePromises.push(item.initialHide());
    console.log({ elementHidePromises: this.elementHidePromises })

    const _self = this;
    $(item).on("openOverlayEvent", function (e) {
      _self.handleItemOpenOverlayEvent(e);
    });
    $(item).on("closeOverlayEvent", function (e) {
      _self.handleItemCloseOverlayEvent(e);
    });

    this.addSwiperSlideFromCard(item);
  }

  handleItemOpenOverlayEvent(e) {
    if (this.activeElement == null) {
      this.activeElement = e.currentTarget;
    } else if (this.activeElement != e.currentTarget) {
      this.activeElement.closeOverlay();
      this.activeElement = e.currentTarget;
    }

    if (isMobile()) {
      this.openSwiper();
    } 
  }

  handleItemCloseOverlayEvent(e) {
    if (e.currentTarget == this.activeElement) {
      this.activeElement = null;
    }

    this.closeSwiper(); 
  }

  createSwiper() {
    const _self = this;
    const swiperEl = $("<div>", { class: "timeline-swiper" });
    const controls = $("<div>", { class: "timeline-swiper__controls" });
    const wrapper = $("<div>", {
      class: "swiper-wrapper timeline-swiper__wrapper",
    });
    const pagination = $("<div>", { class: "timeline-swiper__pagination" });
    const close = $("<div>", {
      class: "timeline-swiper__close",
      html:
        ' <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="currentColor"/></svg>',
    }).on("click", function () {
      _self.closeSwiper();
    });

    controls.append(pagination, close);
    swiperEl.append(wrapper, controls);

    $("body").append(swiperEl);

    this.swiper = new Swiper(".timeline-swiper", {
      speed: 400,
      spaceBetween: 0,
      wrapperClass: "timeline-swiper__wrapper",
      pagination: {
        el: pagination[0],
        type: "fraction",
      },
      on: {
        slideChange: function() {
          const color = $('p', this.slides[this.activeIndex]).css('color');
          $('.timeline-swiper__controls').css('color', color);
        },
      }
    });
  }

  openSwiper() {
    $("body").addClass("timeline-swiper-is-open");
    this.swiper.$el.addClass("is-open");

    const color = $('p', this.swiper.slides[this.swiper.activeIndex]).css('color');
    $('.timeline-swiper__controls').css('color', color);
  }

  closeSwiper() {
    $("body").removeClass("timeline-swiper-is-open");
    this.swiper.$el.removeClass("is-open");
  }

  addSwiperSlideFromCard(item) {
    let slide = null;

    if ($(item.element).hasClass('birthday-item--year')) {
      const year = $('p', item.element).clone();

      slide = $('<div>', { class: 'swiper-slide timeline-swiper__slide timeline-swiper__slide--year'});
      slide.append(year);
    } else {
      const category = item.overlayCard.length > 0 ? $('p', item.overlayCard).first().clone() : $('<div>');
      const icon = $('.birthday-icon', item.element).clone();
      const content = $('.overlay-content .content', item.overlayCard).clone();
      const date = $('.overlay-content date', item.overlayCard).clone(); 
      const colorClass = 'has-twenty-years-' + $(item.overlayCard).data('bgcolor') + '-background-color';

      slide = $('<div>', { class: 'swiper-slide timeline-swiper__slide ' + colorClass });
      slide.append(category, icon, content, date);
    }

    this.swiper.appendSlide(slide);
  }

  filterElements(categories) { 
    this.elements.map(function(item) {
      if (categories.length == 0) { 
        $(item.element).fadeIn();
      } else { 
        const cat = item.category;

        if (categories.includes(cat)) {
          $(item.element).fadeIn();
        } else {
          $(item.element).fadeOut(); 
        }
      }
    })

    console.log(categories);
  }
}
